import React from 'react';
import StudentList from './components/StudentList';

function App() {
  return (
    <div>
      <StudentList />
    </div>
  );
}

export default App;
